import { useSale } from "../contexts/SaleContext";
import React, { useRef, useState } from "react";
import { mutate } from "swr";
import { Alert, AutoComplete, Button, Card, Checkbox, Col, Form, Input, InputNumber, message, Modal, Popconfirm, Radio, Row, Select, Spin, Space, Switch, Tag } from "antd";
import { formatInputNumber, parseInputNumber, roundValue, textNumberFormater } from "../utils";
import { useCompany } from "../contexts/CompanyContext";
import { useConfig } from "../contexts/ConfigContext";
import { saleStatus } from "../config/const";
import { useSecureRequest } from "../hooks/useSecureRequest";
import { IMovementRS, TPayment } from "../models/salesModel";
import { useSession } from "../contexts/CashSessionContext";
import { MinusCircleOutlined, PlusOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useUser } from "../contexts/UserContext";
import { usePos } from "../contexts/PosContext";
import { useRegister } from "../contexts/RegisterContext";
import { UnifiedContactModal } from "@ryo/ui";
import { useContact } from "../contexts/ContactContext";
import dayjs from "dayjs";

const customer = {
  name: "Consumidor final",
  document_number: "222222222222",
  document_type: "NIT",
  uid: "CONSUMIDOR_FINAL",
  id: -1,
  email: "",
  phone: "",
  address: ""
}

function CreateBillModal(props:any){
const {sale,updateSale} = useSale()
const {user} = useUser()
const {company} = useCompany()
const {config} = useConfig()
const {pos} = usePos()
const {session} = useSession()
const {register} = useRegister()
const {contact: contactState, updateContact} = useContact()

const isElectronicInvoicingEnabled = company.moduleOptions?.some(
  opt => (opt.key === "FACTUS_ENABLED" || opt.type === "ELECTRONIC_INVOICING") && (opt.show || (opt as any).is_active_for_company)
) || false;

const idCounter = useRef(-1);
const getNextId = () => --idCounter.current;

const [form] = Form.useForm()
const [loading, setLoading] = useState(false)
const [payWarning,setPayWarning] = useState(false)
const [enableAdd,setEnableAdd] = useState(false)
const [customerData, setCustomerData] = useState(customer)
const [payments, setPayments] = useState([{id:-1,key:"CASH"}]);
const [options, setOptions] = useState<{ value: string; label: string; entity: any; hasNoDoc?: boolean }[]>([]);
const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);

const [messageApi, contextHolder] = message.useMessage();
const { Option } = Select
const { securePost } = useSecureRequest()

  // Initial fetch for contacts & reset on open
  React.useEffect(() => {
    if (sale.showBill) {
      if (company?.current?.uid) {
        handleAutocompleteSearch('');
      }
      form.resetFields();
      setCustomerData(customer);
    }
  }, [company?.current?.uid, sale.showBill]);

  let totalReturn = 0
  const total = roundValue((sale.currentPending?.total_amount || 0) + (sale.currentPending?.total_tax_amount || 0) - (sale.currentPending?.total_discount_amount || 0))
  const initialDataForm = {
    execution_mode: "IMMEDIATE",
    payment_term: "CASH",
    credit_days: 30,
    [`pay_method_${payments[0].id}`]: payments[0].key,
    [`amount_${payments[0].id}`]: total,
    cash_return_amount: sale.currentPending?.cash_return_amount || 0,
    total_discount_amount: sale.currentPending?.total_discount_amount || 0,
    is_electronic_invoice: isElectronicInvoicingEnabled,
    send_email: true,
    customer_email: customerData.email || ""
  }
  console.log("CurrentPending",sale.currentPending)

  const changeReceived = (value:number | null) => {
    const formValues = form.getFieldsValue()
    const currentTerm = formValues.payment_term || "CASH"
    let totalPaid = 0
    for(const key in formValues){
      if(key.startsWith("amount_") && formValues[key] !== undefined && formValues[key] !== null){
        totalPaid += Number(formValues[key])
      }
    } 
    if (currentTerm === "CREDIT") {
      const pendingBalance = Math.max(0, total - totalPaid)
      form.setFieldsValue({ cash_return_amount: roundValue(pendingBalance) })
      setEnableAdd(totalPaid < total)
    } else {
      totalReturn = totalPaid - total
      setEnableAdd(totalPaid < total)
      form.setFieldsValue({ cash_return_amount: roundValue(totalReturn) })
    }
  }

  const getPayments = (values: any) => {
    const aux:Partial<TPayment>[] = []
    Object.keys(values).forEach(key => {
      if(key.startsWith("amount_") || key.startsWith("pay_method_" )){
        const paymentId = key.split("_").pop()! || "-1"
        const id = Number(paymentId)
        const index = aux.findIndex((item) => item.id === id)
        if(index === -1){
          const payMethodValue = values[`pay_method_${paymentId}`]
          const payModuleOption = register.paymentOptions.find((item) => item.key === payMethodValue) || { key: payMethodValue || "CASH", legal_code: "10" }
          const payAmount = roundValue(Number(values[`amount_${paymentId}`]) || 0)
          if (payAmount > 0) {
            aux.push({
              id: id,
              document_id: sale.currentPending?.id,
              payment_method: payModuleOption.key,
              payment_method_code: payModuleOption.legal_code,
              amount: payAmount,
              reference: values[`reference_${paymentId}`]
            })
          }
          delete values[`amount_${paymentId}`]
          delete values[`pay_method_${paymentId}`]
          delete values[`reference_${paymentId}`]
        }
      }
    })
    return {payments:aux,formValues:values}
  }
  
  const removePay = (id:number) => {
    if(id > 0){
      message.error("No se puede eliminar un impuesto que ya se encuentra registrado")
      return
    }
    const filterResult = payments.filter(item => item.id !== id)
    const result = filterResult.length ? filterResult : [{ id: -1,key:"CASH"}]
    if(result[0].id === -1 && result.length === 1 && payments.length === 1){
      form.setFieldsValue({[`pay_method_${result[0].id}`]: "CASH"})
    }
    setPayments(result)
    const formValues = form.getFieldsValue()
    let totalPaid = 0
    for(const key in formValues){
      if(key.startsWith("amount_") && formValues[key] && !key.includes(id.toString())){
        totalPaid += formValues[key]
      }
    } 
    totalReturn = totalPaid - total
    form.setFieldsValue({cash_return_amount:roundValue(totalReturn)})
  }

  const scanForEmptyFields = (data:any,setData:any,setShoWarning:any,key:string)=>{
    const values = form.getFieldsValue()
    console.log("Values: ",values)
    let emptyValues = false
    for(const str in values){
      emptyValues = str.startsWith(key) && values[str] === undefined
      if(emptyValues) {
        break
      }
    }
    if(emptyValues){
      setShoWarning(true)
    }else{
      const id = getNextId()
      setData([...data, { id: id,key:"CASH" }]);
      form.setFieldsValue({[`pay_method_${id}`]: "CASH"})
      setShoWarning(false)
    }
  }
  const onChangePayMethod = (value:any,id:number) => {
    const payArray = [...payments]
    const index = payArray.findIndex(item => item.id === id)
    if(index === -1){
      return
    }
    payArray[index].key = value
    setPayments(payArray)
  }

const generateBill = async (event:any) => {
  const isCredit = event.payment_term === "CREDIT";
  const {payments} = getPayments(event);
  const totalPaid = payments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
  const balanceDue = Math.max(0, roundValue(total - totalPaid));

  if (!isCredit && totalPaid < total) {
    return alert("En venta de contado, aún hay valores pendientes por cubrir");
  }

  const creditDays = Number(event.credit_days) || 30;
  const creditDueDate = dayjs().add(creditDays, 'day').format('YYYY-MM-DD');

  setLoading(true);
  const {currentPending} = sale;
  const currentBill = currentPending as IMovementRS;
  currentBill.cash_return_amount = event.cash_return_amount;
  currentBill.created_by_user_id = user.id;
  currentBill.created_by_user_document = user.document_number;
  currentBill.created_by_user_name = user.name;
  currentBill.approved_by_user_document = user.document_number;
  currentBill.approved_by_user_name = user.name;
  currentBill.approved_by_user_id = user.id;
  currentBill.contact_id = customerData.id;
  currentBill.contact_document = customerData.document_number;
  currentBill.contact_name = customerData.name;
  currentBill.pos_uid = pos.currentSelected.uid;
  currentBill.pos_name = pos.currentSelected.name;
  currentBill.company_id = company.current.id;
  currentBill.payments = payments;
  const {id,uid,created_at,updated_at,item_list,...newPending} = currentBill;
  
  const emitAsElectronic = isElectronicInvoicingEnabled && event.is_electronic_invoice !== false;

  const executionMode = event.execution_mode || "IMMEDIATE";
  const receptionStatus = executionMode === "DEFERRED" ? "PENDING" : "RECEIVED";
  const paymentStatus = isCredit ? (totalPaid >= total ? "PAID" : totalPaid > 0 ? "PARTIALLY_PAID" : "UNPAID") : "PAID";
  const settlementStatus = (receptionStatus === "RECEIVED" && paymentStatus === "PAID") ? "SETTLED" : "OPEN";

  const saleData:Partial<IMovementRS> = {
    ...newPending,
    uid,
    item_list,
    cash_session_id: session.currentSelected?.id,
    storehouse_from_id: pos.currentSelected?.storehouse_id,
    document_type: "SALE_INVOICE",
    invoice_type: emitAsElectronic ? "ELECTRONIC_INVOICE" : "SIMPLE_RECEIPT",
    electronic_invoice_send_email: emitAsElectronic ? (event.send_email !== false) : false,
    status: saleStatus.APPROVED,
    payment_term: isCredit ? "CREDIT" : "CASH",
    execution_mode: executionMode,
    reception_status: receptionStatus,
    settlement_status: settlementStatus,
    credit_days: isCredit ? creditDays : 0,
    credit_due_date: isCredit ? creditDueDate : undefined,
    balance_due_amount: isCredit ? balanceDue : 0,
    total_paid_amount: totalPaid,
    payment_status: paymentStatus,
    created_by_user_id: user.id,
    approved_by_user_id: user.id,
    delivered_by_user_id: user.id,
    payments: currentBill.payments
  };
  console.log("Saledata:",saleData);
  const billResponse = await securePost("/inventory/movement/update-movement",{
    company:company.current.uid,
    uidMovement:uid,
    movement: saleData,
    module: config.module,
    typeMovement: "REGISTER_SALE"
  });
  if(billResponse.status === 200){
    updateSale({pendingList:[],showBill: false,item_list:[],currentPending:null})
    form.resetFields();
    setCustomerData(customer);
    mutate(
      key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
      undefined,
      { revalidate: true }
    )
    success()
  }else{
    fail("Por favor intente nuevamente")
  }
  setLoading(false)
}
const success = () => {
  messageApi.open({
    type: 'success',
    content: 'Registro creado con éxito',
  });
};
const fail = (content:string) => {
  messageApi.open({
    type: 'error',
    content,
  });
};

const footer = [
  <div key="confirm" style={{ textAlign: "left" }}>
    <Popconfirm
      title="¿Estás seguro de realizar esta acción?"
      okButtonProps={{htmlType:"submit",form:"create-bill"}}
      okText="Sí"
      cancelText="No"
    >
      <Button type="primary" htmlType="button">Generar documento</Button>
    </Popconfirm>
  </div>,
]
const totalSale = (sale.currentPending?.total_amount_full || 0)

const onSearch = (event: any) => {
  const document = event.target.value || ""
  if (!document || (customerData.id !== -1 && document === customerData.document_number)) return;
  
  const documentNumber = Number(document)
  if (Number.isNaN(documentNumber)) {
    return;
  }
  setLoading(true);

  (async () => {
    const userResponse = await securePost('/user/contact/get-contact-by-id',{
      company:company.current.uid,
      idContact:documentNumber.toString()
    })
    if(userResponse.status === 200 && userResponse.contact?.id){
      const contactObj = userResponse.contact;
      const contactEmail = contactObj.email || contactObj.electronic_invoice_email || contactObj.mail || "";
      setCustomerData({
        name: contactObj.name,
        document_number: documentNumber.toString(),
        document_type: contactObj.document_type || "CC",
        id: contactObj.id,
        uid: contactObj.uidUser || contactObj.uid,
        email: contactEmail,
        phone: contactObj.phone || contactObj.mobile || "",
        address: contactObj.address || ""
      })
      form.setFieldValue("contact_name", contactObj.name)
      form.setFieldValue("contact_document", documentNumber.toString())
      form.setFieldValue("customer_email", contactEmail || "")
      form.setFieldValue("send_email", Boolean(contactEmail))
    }else{
      fail("Cliente no encontrado")
      form.setFieldValue("contact_name", "")
      form.setFieldValue("customer_email", "")
      form.setFieldValue("send_email", false)
      setCustomerData(customer)
    }
    setLoading(false)
  })()
}

const handleAutocompleteSearch = (searchText: string) => {
  if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
  
  searchTimeoutRef.current = setTimeout(async () => {
    try {
      const response = await securePost('/user/contact/search-bulk-contacts', {
        company: company.current.uid,
        search: searchText,
        type: 'light',
        role: 'CUSTOMER'
      });

      if (response.status === 200) {
        const mapped = (response.contactList || []).map((item: any) => {
          const hasNoDoc = !item.document_number || String(item.document_number).trim() === '';
          return {
            value: item.document_number ? String(item.document_number) : `_no_doc_${item.id}`,
            label: hasNoDoc 
              ? `⚠️ Sin documento - ${item.name || item.fullName}` 
              : `${item.name || item.fullName} (${item.document_number || item.id})`,
            entity: item,
            hasNoDoc
          };
        });
        setOptions(mapped);
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  }, 500);
};

const handleCreateContactSuccess = (newContact: any) => {
  updateContact({ showModal: false, current: undefined });
  const name = newContact.name || newContact.fullName;
  const documentNumber = newContact.document_number;
  const contactEmail = newContact.email || newContact.electronic_invoice_email || newContact.mail || "";

  setCustomerData({
    name: name,
    document_number: documentNumber,
    document_type: newContact.document_type || 'NIT',
    id: newContact.id,
    uid: newContact.uidUser || newContact.uid,
    email: contactEmail,
    phone: newContact.phone || newContact.mobile || "",
    address: newContact.address || ""
  });
  form.setFieldValue("contact_name", name);
  form.setFieldValue("contact_document", documentNumber);
  form.setFieldValue("customer_email", contactEmail || "");
  form.setFieldValue("send_email", Boolean(contactEmail));
  setOptions([]);
};

const handleSaveContact = async (values: any) => {
  const isEdit = !!values.uid
  const dataRequest: any = {
    company: company.current?.uid,
    module: config.module,
    contact: { ...values, company_id: company.current?.id }
  }

  let url = "/user/contact/create-contact"
  if (isEdit) {
    dataRequest.uidContact = values.uid
    dataRequest.contact.id = values.id
    url = "/user/contact/update-contact"
  } else {
    dataRequest.contact.roles = [{ role_type: "CUSTOMER" }]
  }

  const res = await securePost(url, dataRequest)
  if (res.status !== 200) {
    throw new Error(res.message || "Error al guardar el contacto")
  }
  return res.contact;
};

const handleResetCustomer = () => {
  setCustomerData(customer);
  form.setFieldsValue({
    contact_document: undefined,
    contact_name: undefined,
    customer_email: "",
    send_email: true
  });
  handleAutocompleteSearch('');
};

const handleSelect = (val: string, option: any) => {
  const entity = option.entity;

  if (option.hasNoDoc) {
    message.warning('Este contacto no tiene número de documento. Por favor, actualice sus datos.');
    updateContact({ showModal: true, current: entity });
    setCustomerData(customer);
    form.setFieldValue("contact_name", "");
    form.setFieldValue("customer_email", "");
    form.setFieldValue("send_email", false);
    setTimeout(() => form.setFieldValue("contact_document", undefined), 10);
    return;
  }

  const contactEmail = entity.email || entity.electronic_invoice_email || entity.mail || "";

  setCustomerData({
    name: entity.name,
    document_number: entity.document_number,
    document_type: entity.document_type,
    id: entity.id,
    uid: entity.uidUser,
    email: contactEmail,
    phone: entity.phone || entity.mobile || "",
    address: entity.address || ""
  });
  form.setFieldValue("contact_name", entity.name);
  form.setFieldValue("contact_document", entity.document_number);
  form.setFieldValue("customer_email", contactEmail || "");
  form.setFieldValue("send_email", Boolean(contactEmail));
  setOptions([]);
};

const customerName = Form.useWatch("contact_name",form)
const isElectronicInvoiceWatch = Form.useWatch("is_electronic_invoice",form)
const paymentTermWatch = Form.useWatch("payment_term", form) || "CASH"
const isCustomerSelected = customerData.id !== -1 || Boolean(customerName);

return (
  <Modal
    title={`Total a pagar: $ ${textNumberFormater(total)} - Total venta: $ ${textNumberFormater(totalSale)}`}
    open={sale.showBill}
    maskClosable={false}
    confirmLoading={loading}
    onCancel={() => {
      updateSale({ showBill: false });
      form.resetFields();
      setCustomerData(customer);
    }}
    className="modal-responsive-md"
    footer={footer}
    >
    <Spin size="large" tip="Procesando..." fullscreen spinning={loading} />
    {contextHolder}
    <Form
      form={form}
      name="create-bill"
      layout="vertical"
      initialValues={initialDataForm}
      scrollToFirstError={{ block: 'end', focus: true }}
      style={{ maxWidth: '800px', margin: '0 auto'}}
      onFinish={generateBill}>
      <Row gutter={[10,10]} style={{marginBottom:20}}>
        <Col sm={12} xs={24}>
          <Form.Item
              label={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <span>Documento cliente</span>
                  {isCustomerSelected && (
                    <Button
                      type="link"
                      size="small"
                      danger
                      icon={<CloseCircleOutlined />}
                      onClick={handleResetCustomer}
                      style={{ padding: 0, height: 'auto', fontSize: '12px' }}
                    >
                      Cambiar cliente
                    </Button>
                  )}
                </div>
              }
              name={`contact_document`}
              rules={[{ required: true, message: ''}]}
            >
            <AutoComplete
                options={options}
                onSearch={handleAutocompleteSearch}
                onSelect={handleSelect}
                onChange={(val) => {
                  const selectedOption = options.find((opt: any) => opt.value === val);
                  if (selectedOption?.hasNoDoc) {
                    setTimeout(() => form.setFieldValue("contact_document", undefined), 10);
                  }
                  if (!val || String(val).trim() === '') {
                    handleResetCustomer();
                  }
                }}
                onFocus={() => {
                  if (options.length === 0) {
                    handleAutocompleteSearch('');
                  }
                }}
                disabled={isCustomerSelected}
                notFoundContent={
                  loading ? (
                    <div style={{ padding: 8, textAlign: 'center' }}><Spin size="small" /></div>
                  ) : (
                    <div style={{ padding: '8px 12px', color: '#999' }}>No se encontraron resultados</div>
                  )
                }
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div style={{ margin: '8px 0', height: 1, backgroundColor: '#f0f0f0' }} />
                    <Space style={{ padding: '0 8px 4px' }}>
                      <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => updateContact({ showModal: true, current: undefined })}
                        size="small"
                        style={{ width: '100%' }}
                      >
                        Crear Cliente
                      </Button>
                    </Space>
                  </>
                )}
              >
                <Input 
                  placeholder="# identificación o nombre"
                  onBlur={onSearch}
                  style={{ width: "100%" }} 
                />
              </AutoComplete>
            </Form.Item>
        </Col>
        <Col sm={12} xs={24}>
          <Form.Item
              label="Nombre"
              name={`contact_name`}
              rules={[{ required: true, message: ''}]}
            >
              <Input type="text" disabled placeholder="Nombre del cliente"/>
            </Form.Item>
        </Col>
      </Row>

      <Card size="small" style={{ marginBottom: 16, backgroundColor: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
        <Row gutter={[16, 12]} align="middle">
          <Col xs={24} sm={12}>
            <Form.Item
              label="Flujo de Entrega / Despacho"
              name="execution_mode"
              initialValue="IMMEDIATE"
              tooltip="Inmediato: La mercancía se entrega ya mismo al cliente en mostrador. Diferido: Queda pendiente por despachar/entregar por bodega."
              style={{ marginBottom: 0 }}
            >
              <Radio.Group buttonStyle="solid">
                <Radio.Button value="IMMEDIATE">⚡ Entrega Inmediata</Radio.Button>
                <Radio.Button value="DEFERRED">📦 Despacho Diferido</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Condición de Pago"
              name="payment_term"
              initialValue="CASH"
              style={{ marginBottom: 0 }}
            >
              <Radio.Group
                buttonStyle="solid"
                onChange={(e) => {
                  const newTerm = e.target.value;
                  if (newTerm === "CREDIT") {
                    form.setFieldsValue({ [`amount_${payments[0].id}`]: 0 });
                    changeReceived(0);
                  } else {
                    form.setFieldsValue({ [`amount_${payments[0].id}`]: total });
                    changeReceived(total);
                  }
                }}
              >
                <Radio.Button value="CASH">⚡ Contado</Radio.Button>
                <Radio.Button value="CREDIT">📋 Crédito</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
          {paymentTermWatch === "CREDIT" && (
            <Col xs={24} sm={12}>
              <Form.Item
                label="Plazo de Crédito"
                name="credit_days"
                initialValue={30}
                style={{ marginBottom: 0 }}
              >
                <Select style={{ width: '100%' }}>
                  <Option value={8}>8 días</Option>
                  <Option value={15}>15 días</Option>
                  <Option value={30}>30 días</Option>
                  <Option value={45}>45 días</Option>
                  <Option value={60}>60 días</Option>
                  <Option value={90}>90 días</Option>
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Card>
      
      {payments.map((pay,index) => (
        <Row key={pay.id} gutter={[10,10]} align="middle">
          <Col span={12}>
            <Form.Item
              label= {index === 0 ? (paymentTermWatch === "CREDIT" ? "Medio de pago inicial" : "Medio de pago") : ""}
              name={`pay_method_${pay.id}`}
              rules={[{ required: true, message: 'Selecciona el medio pago' }]}
            >
            <Select placeholder="Selecciona el medio pago" onChange={(value) => onChangePayMethod(value,pay.id)}>
              {register.paymentOptions.map(payMethod => (
                <Option key={payMethod.id} value={payMethod.key}>{payMethod.string_value}</Option>
              ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label={index === 0 ? (paymentTermWatch === "CREDIT" ? "Abono inicial (Opcional)" : "Total recibido") : ""}
              name={`amount_${pay.id}`}
              rules={[
                { required: paymentTermWatch !== "CREDIT", message: "Ingrese el monto a pagar" },
                {
                  type: "number",
                  min: paymentTermWatch === "CREDIT" ? 0 : 1,
                  message: paymentTermWatch === "CREDIT" ? "El monto no puede ser negativo" : "El monto mínimo es 1"
                }
              ]}>
              <InputNumber 
                prefix="$" 
                min={paymentTermWatch === "CREDIT" ? 0 : 1} 
                style={{width:"100%"}} 
                formatter={formatInputNumber}
                parser={parseInputNumber}
                placeholder={paymentTermWatch === "CREDIT" ? "0 (Crédito total)" : "Monto recibido"}
                onChange={(e) => changeReceived(e)}>
              </InputNumber>
            </Form.Item>
          </Col>
          <Col span={2} style={{marginTop: index === 0 ? "16px":"-12px"}}>
          {
            payments.length > 1 ? (
              <MinusCircleOutlined 
                onClick={() => removePay(pay.id)}
              />
            ) : null
          }
          </Col>
          {form.getFieldValue(`pay_method_${pay.id}`) !== "CASH" && <Col xs={24} sm={{span:12}}>
            <Form.Item
              label= "Referencia"
              name={`reference_${pay.id}`}
              rules={[{ 
                required: (Number(form.getFieldValue(`amount_${pay.id}`)) || 0) > 0, 
                message: 'Ingrese la referencia de pago' 
              }]}
            >
              <Input placeholder="Referencia" style={{ width: '100%', marginBottom: "1em" }}></Input>
            </Form.Item>
          </Col>}
        </Row>
      ))}
      <Row gutter={[20,10]}>
        <Col xs={24} sm={20}>
          {payWarning && <Alert
            message="Complete los campos antes de añadir otro pago"
            banner
            closable
            onClose={()=>setPayWarning(false)}
          />}
        </Col>
      </Row>
      {enableAdd && <Row gutter={[20,10]} style={{marginBottom:5}}>
        <Col xs={8} sm={5}>
          <Button type="dashed" style={{marginTop:"5px"}} onClick={() => scanForEmptyFields(payments,setPayments,setPayWarning,'amount_')}>Agregar pago</Button>
        </Col>
      </Row>}
      <Row gutter={[10,10]}> 
        <Col sm={12} xs={24}>
          <Form.Item
            label="Descuento total"
            name="total_discount_amount"
            rules={[{ required: false,message:"" }]}>
            <InputNumber 
              prefix="$" min={0} 
              style={{width:"100%"}} 
              formatter={formatInputNumber}
              parser={parseInputNumber}
              disabled>
            </InputNumber>
          </Form.Item>
        </Col>   
        <Col sm={12} xs={24}>
          <Form.Item
            label={paymentTermWatch === "CREDIT" ? "Saldo a Crédito (Pendiente)" : "Total devolución"}
            name="cash_return_amount"
            rules={[{ required: true, message: "Valide el total de la venta" }]}>
            <InputNumber 
              prefix="$" min={0} 
              style={{ width: "100%", color: paymentTermWatch === "CREDIT" ? "#f5222d" : undefined, fontWeight: 600 }} 
              formatter={formatInputNumber}
              parser={parseInputNumber}
              disabled>
            </InputNumber>
          </Form.Item>
        </Col>
      </Row>

      {isElectronicInvoicingEnabled && (
        <div style={{
          backgroundColor: '#f6ffed',
          border: '1px solid #b7eb8f',
          borderRadius: 8,
          padding: '12px 16px',
          marginBottom: 16
        }}>
          <Row justify="space-between" align="middle" style={{ marginBottom: isElectronicInvoiceWatch !== false ? 12 : 0 }}>
            <Space>
              <Tag color="green" style={{ fontSize: 13, padding: '2px 8px' }}>
                DIAN
              </Tag>
              <strong style={{ color: '#237804' }}>Factura Electrónica de Venta</strong>
            </Space>
            <Form.Item name="is_electronic_invoice" valuePropName="checked" noStyle>
              <Switch checkedChildren="Sí" unCheckedChildren="No" />
            </Form.Item>
          </Row>

          {isElectronicInvoiceWatch !== false && (
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item
                  name="customer_email"
                  label="Correo electrónico del cliente"
                  rules={[
                    { type: 'email', message: 'Ingrese un correo electrónico válido' }
                  ]}
                  style={{ marginBottom: 8 }}
                >
                  <Input placeholder="correo@ejemplo.com" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="send_email" valuePropName="checked" noStyle>
                  <Checkbox defaultChecked>
                    Enviar factura electrónica automáticamente al correo del cliente
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          )}
        </div>
      )}
    </Form>
    <UnifiedContactModal 
      visible={contactState?.showModal || false}
      onCancel={() => updateContact({ showModal: false, current: undefined })}
      onSuccess={handleCreateContactSuccess}
      onSave={handleSaveContact}
      role="CUSTOMER"
      initialValues={contactState?.current}
      validationMode="strict"
    />
  </Modal>

)

}

export default CreateBillModal